module.exports = __webpack_public_path__ + "img/rir-logo-default.0c226b85.svg";